import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import alertify from "alertifyjs";
import { ApiServiceService } from "../../../Services/api-service.service";
import { Observable } from "rxjs";
import {CurrencyPipe} from "@angular/common";
import {AuthService} from "../../../Services/auth.service";

@Component({
  selector: "app-create-mda-service",
  templateUrl: "./create-mda-service.component.html",
  styleUrls: ["./create-mda-service.component.css"],
})
export class CreateMdaServiceComponent implements OnInit {
  confirm = new EventEmitter();
  cancel = new EventEmitter();
  errorMessage: string;
  form: FormGroup;
  searching: boolean;
  showErrorMessageTrigger: boolean;
  successMessage: string;
  showSuccessMessageTrigger: boolean;
  @Output() completed = new EventEmitter<void>();
  submitting: boolean;
  rateType: string[] = ["FIXED", "FLAT", "VARIABLE", "CUSTOM"];
  mdaExtendedRevenue: any[] = [];
  mdaList: any[] = [];
  mdaExtendedRevenue$: Observable<any[]>;
  mdaList$: Observable<any[]>;
  mdaName: string;
  mdaId: string;

  newUploadFile: string = '';
uploadFiles: {name: string}[] = [];

customServices: { name: string; type: string; description: string; amount: string; regAmount: string; renewalAmount: string }[] = [];


  ngOnInit(): void {

    this.mdaName = this.authService.getDeptName();
    this.mdaId = this.authService.getDept();

    this.form = this.fb.group({
      name: [this.authService.getDeptName()],
      mdaListId: [this.authService.getDeptName()],
      revenueId: [null, [Validators.required]],
      revenueCode: ["", [Validators.required]],
      serviceType: ["", [Validators.required]],
      revenueDescription: ["", [Validators.required]],
      amount: [""],
      location: [false,[Validators.required]],
      land: [false,[Validators.required]],
      uploads: [false,[Validators.required]],
      period: [false,[Validators.required]],
      customName: [""],
      customType: [""],
      customAmount: [""],
      customDescription: [""],

      customRegAmount: [""],
      customRenewalAmount: [""],
    });
    // this.getExtendedRevenue();
    // this.getMdalist();

    // this.form.get("mdaListId").valueChanges.subscribe((v) => {
    //   if (v !== "" || v !== null || v !== undefined) {
    //     this.mdaList$?.subscribe((d: any[]) => {
    //       const result = d?.find((x: any) => x?.id == v);
    //       const name = result?.name;
          this.getExtendedRevenue(this.authService.getDept());
    //       if (name !== null) {
    //         this.form.get("name").setValue(name);
    //       }
    //     });
    //   }
    // });
    this.form.get("revenueId").valueChanges.subscribe((v) => {
      if (v !== "" || v !== null || v !== undefined) {
        this.mdaExtendedRevenue$?.subscribe((d: any[]) => {
          this.enableFormFieldsWithValues(this.form, [
            "revenueDescription",
            "revenueCode",
          ]);

          const result = d?.find((x: any) => x?.id == v);
          const description = result?.description;
          const revenueCode = result?.revenueCode;

          if (description !== null && revenueCode !== null) {
            this.form.get("revenueDescription").setValue(description);
            this.form.get("revenueCode").setValue(revenueCode);
            this.disableFormFieldsWithValues(this.form, [
              "revenueDescription",
              "revenueCode",
            ]);
          }
        });
      }
    });


  }

  constructor(
    private fb: FormBuilder,
    private bsModalRef: BsModalRef,
    private apiService: ApiServiceService,
    private authService:AuthService
  ) {}


  addUploadFile() {
    if (!this.newUploadFile || this.newUploadFile.trim() === '') {
      alert('Please enter a file name');
      return;
    }
  
    this.uploadFiles.push({name: this.newUploadFile.trim()});
    this.newUploadFile = ''; 
  }
  
  removeUploadFile(index: number) {
    this.uploadFiles.splice(index, 1);
  }


  addCustomService() {
    const customName = this.form.get('customName')?.value;
    const customType = this.form.get('customType')?.value;
    const customAmount = this.form.get('customAmount')?.value;
    const customDescription = this.form.get('customDescription')?.value;

    const customRegAmount = this.form.get('customRegAmount')?.value;
    const customRenewalAmount = this.form.get('customRenewalAmount')?.value;
  
    if (
      (this.form.get('customType')?.value === 'FIXED' &&
        (!customName || !customType || !customAmount || !customDescription)) ||
      (this.form.get('customType')?.value === 'REGISTRATION_AND_RENEWAL' &&
        (!customName || !customType || !customRegAmount || !customRenewalAmount || !customDescription))
    ) {
      alert('Please fill in all fields');
      return;
    }
    
  
    this.customServices.push({
      name: customName.trim(),
      type: customType,
      description: customDescription.trim(),
      amount: customAmount,
      regAmount: customRegAmount,
      renewalAmount: customRenewalAmount
    });
  
    this.form.patchValue({
      customName: '',
      customType: '',
      customAmount: '',
      customRegAmount: '',
      customRenewalAmount: '',
      customDescription: '',
    });
  }
  
  removeCustomService(index: number) {
    this.customServices.splice(index, 1);
  }

  close(): void {
    this.bsModalRef.hide();
  }

  showSuccessMessage(msg: string): void {
    this.successMessage = msg;
    this.showSuccessMessageTrigger = true;
    window.scroll(0, 0);
    setTimeout(() => {
      this.showSuccessMessageTrigger = false;
    }, 3000);
  }

  showErrorMessage(error): void {
    this.errorMessage = error;
    this.showErrorMessageTrigger = true;
    window.scroll(0, 0);
    setTimeout(() => {
      this.showErrorMessageTrigger = false;
    }, 5000);
  }

  getSuccessMessage(): string {
    return this.successMessage;
  }

  getErrorMessage(): string {
    return this.errorMessage;
  }

  getExtendedRevenue(id:number): void {
    const url = "/assessments/revenues?id="+id;
    this.mdaExtendedRevenue$ = this.apiService.get(url);
  }

  parseNumber(value: string): number {
    if (!value) {
      return 0;
    }
    return Number(value.replace(/,/g, ''));
  }
  

  mapToCustomMDADetailsDto(): CustomMDADetailsDto[] {
    return this.customServices.map(cs => ({
      serviceName: cs.name,
      serviceType: cs.type,
      serviceDescription: cs.description,
      amount: this.parseNumber(cs.amount),
      regAmount: this.parseNumber(cs.regAmount),
      renewalAmount: this.parseNumber(cs.renewalAmount)
    }));
  }

  createMDA(): void {
    this.submitting = true;
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      this.submitting = false;
      return;
    }

    if (this.form.get('serviceType')?.value == 'CUSTOM' && this.customServices.length < 1) {
      this.submitting = false;
      alert('Please add at least one custom service');
      return;
    }

    if (this.form.get('serviceType')?.value == 'CUSTOM' && this.form.get('uploads')?.value && this.uploadFiles.length < 1) {
      this.submitting = false;
      alert('Please add at least one uploadables');
      return;
    }

    const url = "/assessments/create-mda-service";
    
    const formValues = this.form.getRawValue()

    const params: MDADto = {
      name: this.form?.get("name")?.value,
      mdaExtendedRevenueId: this.form?.get("revenueId")?.value,
      revenueCode: this.form?.get("revenueCode")?.value,
      revenueDescription: this.form?.get("revenueDescription")?.value,
      type: this.form?.get("serviceType")?.value,
      amount: this.form?.get("amount")?.value != undefined || this.form?.get("amount")?.value != null ? Number(this.form?.get("amount")?.value.replace(",","")) : this.form?.get("amount")?.value,
      landParamIsApplicable: formValues.land,
      uploadsIsApplicable: formValues.uploads,
      locationIsApplicable: formValues.location,
      periodIsApplicable: formValues.period,
      customMDADetailsList: this.mapToCustomMDADetailsDto(),
      customMDAUploadablesDtoList: this.uploadFiles
    };

    this.apiService.post(url, params).subscribe(
      (response) => {

         this.submitting = false;

        if (response.message.includes('success')){

        alertify.set("notifier", "position", "top-center");
        alertify.success(response.message);

        setTimeout(() => {
          this.close();
          this.completed.emit();
        }, 2000);


        }else{
          alertify.set("notifier", "position", "top-center");
          alertify.error(response.message);

        }
        
      },
      (error) => {
        this.submitting = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
      },
    );
  }

  disableFormFieldsWithValues(
    form: FormGroup,
    fieldsToDisable: string[],
  ): void {
    fieldsToDisable.forEach((formControlName) => {
      const control = form?.get(formControlName);
      if (control.value) {
        control.disable();
      }
    });
  }

  enableFormFieldsWithValues(form: FormGroup, fieldsToDisable: string[]): void {
    fieldsToDisable.forEach((formControlName) => {
      const control = form?.get(formControlName);
      if (control.value) {
        control.enable();
      }
    });
  }

  isServiceType(): boolean {
    return this.form?.get("serviceType")?.value == "VARIABLE";
  }
}

interface MDADto {
  name: string;
  mdaExtendedRevenueId: number;
  revenueCode: string;
  revenueDescription: string;
  type: string;
  amount:number;
  locationIsApplicable: boolean,
  landParamIsApplicable: boolean,
  uploadsIsApplicable: boolean,
  periodIsApplicable: boolean,
  customMDADetailsList: CustomMDADetailsDto[],
  customMDAUploadablesDtoList: CustomMDADetailsUploadsDto[]
}

interface CustomMDADetailsDto {

  serviceName: string;
  serviceType: string;
  amount: number;
  regAmount: number;
  renewalAmount: number;
  serviceDescription: string;
}

interface CustomMDADetailsUploadsDto {
  name: string;
}

